
export default {//改变state里定义的变量的方法,调用方法是this.$store.commit('方法名','要改变的数据')
	setUserInfo(state, obj) {
		state.userInfo = obj;
	},
	setIsLogin(state, boolean) {
		state.isLogin = boolean;
	},
}
